<!--
  -  Copyright (C) 2019 Impulsis <info@impulsis.com>. All rights reserved.
  -
  -  All information herein, source code below as well as the Morpheus system itself and all related
  -  software (“Items”) are proprietary to Impulsis. Impulsis is the sole copyright owner of the Items.
  -  Any use, reproduction, or disclosure of the Items without the written permission of Impulsis
  -  is prohibited.
  -->

<template>
  <v-alert
    :value="shop.enabled"
    color="warning"
    icon="priority_high"
    outline
    class="mb-4"
  >
    Please, disable shop and save to edit listings!
  </v-alert>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  name: 'ShopEnabledAlert',
  props: {
    shop: {
      required: true,
      type: Object,
      default: () => ({})
    }
  }
})
</script>

<style scoped>

</style>
